import React, { createContext, useReducer }  from 'react'
import AppReducer from "./AppReducer.jsx"

const initialState = {
    transactions:[
      { id: 1, text: 'Flower', amount: -20 },
      { id: 2, text: 'Salary', amount: 300 },
    
    ]
}

export const GlobalContext = createContext(initialState); 

export const GlobalProvider = ({children}) => {
    const [state, dispatch] = useReducer(AppReducer, initialState)

    function deleteTransaction (id) {
      dispatch ({
        type:"Delete_Transaction",
        payload:id
      }
      )
    }
    
    function addTransaction (transaction) {
      dispatch({
        type:"Add_Transaction",
        payload:transaction
      })
    }
     return (
         <GlobalContext.Provider 
            value={{transactions:state.transactions, deleteTransaction, addTransaction}} 
         >
                {children}
        </GlobalContext.Provider>
     )   
}